import { useEffect, useState } from "react";
import { Check, X } from "lucide-react";
import { apiClient } from "../lib/api";

export const EquipmentSection = ({ specs, lang }) => {
  const [lib, setLib] = useState([]);
  const has = specs && Object.values(specs).some((v) => v === "yes" || v === "no");
  useEffect(() => {
    if (has) apiClient.get("/spec-library/car").then((r) => setLib(r.data.items || [])).catch(() => {});
  }, [has]);
  const rows = lib.filter((s) => specs?.[s.key] === "yes" || specs?.[s.key] === "no");
  if (!has || !rows.length) return null;
  const ar = lang === "ar";
  return (
    <div className="mt-6 surface rounded-2xl p-6" dir={ar ? "rtl" : "ltr"} data-testid="vehicle-equipment-section">
      <div className="overline mb-3">{ar ? "التجهيزات" : "EQUIPMENT"}</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {rows.map((s) => (
          <div key={s.key} className="flex items-center gap-2 text-sm" data-testid={`equipment-${s.key}`}>
            {specs[s.key] === "yes" ? <Check className="w-4 h-4 text-green-600" /> : <X className="w-4 h-4 text-[#b0b0b0]" />}
            <span className={specs[s.key] === "no" ? "text-[#8a8a8a]" : ""}>{ar ? s.name_ar : s.name_en}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
